export default "__VITE_ASSET__P_pt5wd___"